// extracted by mini-css-extract-plugin
module.exports = {"button":"GalleryCategories_button__OxsYO","wrapper":"GalleryCategories_wrapper__vUtIO"};